export default class AdminTestPlanState {
  constructor() {
    // GET Test Plan List
    this.adminTestPlanList = {
      loading: false,
      data: {},
      error: null,
    };
    this.adminArchivedTestPlanList = {
      loading: false,
      data: {},
      error: null,
    };
    this.adminDraftTestPlanList = {
      loading: false,
      data: {},
      error: null,
    };
    this.adminTestPlanTAgs = {
      loading: false,
      data: [],
      error: null,
    };

    // GET/CREATE/UPDATE/DELETE Test Plan
    this.adminTestPlan = {
      loading: false,
      data: {},
      error: null,
    };
    this.checkTestPlanExisted = {
      loading: false,
      data: {},
      error: null,
    };
    this.archiveTestPlan = {
      loading: false,
      data: {},
      error: null,
    };
    this.editTestPlanTags = {
      loading: false,
      data: {},
      error: null,
    };
  }
}
